import { render, staticRenderFns } from "./costsDatabase.vue?vue&type=template&id=4ebd76d8&"
import script from "./costsDatabase.vue?vue&type=script&lang=js&"
export * from "./costsDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports